import { render } from "./ourservicesComponent.vue?vue&type=template&id=d927cf98&scoped=true"
import script from "./ourservicesComponent.vue?vue&type=script&lang=js"
export * from "./ourservicesComponent.vue?vue&type=script&lang=js"

import "./ourservicesComponent.vue?vue&type=style&index=0&id=d927cf98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d927cf98"]])

export default __exports__